import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearFacetValues,
  EDIT_SOURCE,
  selectAppliedFacetChips,
  toggleFacetValues,
} from "../modules/facets";

export function useSelectedFacets() {
  const dispatch = useDispatch();

  const displayedFacetValues = useSelector(selectAppliedFacetChips);

  const removeFacetValues = useCallback(
    (toggledFacets) => {
      dispatch(toggleFacetValues(toggledFacets, EDIT_SOURCE.OUTSIDE_PANEL));
    },
    [dispatch],
  );

  const clearFacet = useCallback(
    (facetId) => {
      dispatch(clearFacetValues(facetId, EDIT_SOURCE.ALWAYS_COMMITS));
    },
    [dispatch],
  );

  return {
    selectedFacets: displayedFacetValues,
    displayedFacetValues,
    removeFacetValues,
    clearFacet,
  };
}
